import styled from 'styled-components';
import  CountUp  from 'react-countup';
import { THEME } from '../../../../../themes';
import { CaptionFont, HeadlineFont } from '../../../../../themes/fonts';

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Label = styled.div`
  ${CaptionFont};
  opacity: 0.6;
  color: ${THEME.COLORS.CONTENT_PRIMARY};
`;

export const Title = styled.span`
  ${HeadlineFont};
  color: ${THEME.COLORS.CONTENT_PRIMARY};
  font-weight: 600;
  gap: 2px;
`;

export const Years = styled(CountUp)`
  color: ${THEME.COLORS.ACCENT};
  margin-right: ${THEME.SPACING.MICRO};
  ${HeadlineFont};
  font-weight: 600;
  gap: 2px;
`;

export const Description = styled.span`
  opacity:${THEME.OPACITY.MED};
  ${CaptionFont};
  color: ${THEME.COLORS.CONTENT_PRIMARY};
  font-weight: 500;
`;

export const MarkedText = styled(Description)`
  text-decoration: underline;
  font-weight: bold;
`;

export const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;
`;
